import { render, staticRenderFns } from "./BlockSidebarPanel.vue?vue&type=template&id=d0109c08&scoped=true&"
import script from "./BlockSidebarPanel.vue?vue&type=script&lang=js&"
export * from "./BlockSidebarPanel.vue?vue&type=script&lang=js&"
import style0 from "./BlockSidebarPanel.vue?vue&type=style&index=0&id=d0109c08&lang=scss&scoped=true&"
import style1 from "./BlockSidebarPanel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0109c08",
  null
  
)

export default component.exports